export default "__VITE_ASSET__CAyu7iew__"